import { ONE_SECOND } from '@lucidlink/uicore';
export const trackRetries = () => {
    let retriesCount = 0;
    let retryWaitMs = 0;
    const onRetry = ({ delayMs }) => {
        retriesCount++;
        retryWaitMs += delayMs;
    };
    return {
        onRetry,
        retryFacts: () => ({
            retriesCount,
            retryWaitSeconds: retryWaitMs / ONE_SECOND,
        }),
    };
};
